import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Modal from 'common/components/modal-full';
import CouponDetails from 'common/components/banner/coupon-details';
import { getModifierClass } from 'common/util/css-class-helper';
import SubscribeBody from 'common/components/banner/suscribe-body';
import styles from 'commonStyles/components/loyalty/_perks-sign-up-modal';
import useResponsive from 'common/components/hooks/use-responsive';
import { translate } from 'common/localization';

import PullUpTransition from 'common/components/transitions/pull-up-transition';
import FadeTransition from 'common/components/transitions/fade-transition';
import defaultStyles from 'styles/components/coupon/_coupon-content';
import BcsCloseIcon from 'bcs/icons/close';

const dispatchOverlayEvent = (overlay) => {
  document.dispatchEvent(
    new CustomEvent('bc_chat::overlay', {
      detail: { isOverlay: overlay, source: 'ntf-mobile' },
    })
  );
};

const SubscribeModal = (props) => {
  const {
    isAnimated,
    closeBanner,
    type,
    handleCloseDetails,
    handleOpenDetails,
    isShowingDetails,
    startChat,
    restrictions,
    title,
  } = props;
  const isAnimatedModifier = isAnimated ? 'animated' : '';
  const [isOpen, setIsOpen] = useState(false);
  const [isPullAnimationDone, setPullAnimationDone] = useState(false);
  const { medium } = useResponsive();
  const contentClass = getModifierClass('subscribe__banner__content', isAnimatedModifier);

  useEffect(() => {
    if (medium) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
      dispatchOverlayEvent(true);
    }
  }, [medium]);

  const onModalBackgroundClick = () => {
    setIsOpen(false);
    onClose();
  };

  const onClose = () => {
    dispatchOverlayEvent(false);
    closeBanner();
  };

  return (
        <>
          {!medium && (
            <PullUpTransition in appear={isAnimated} onEntered={() => setPullAnimationDone(true)}>
              <div role="region" aria-label={translate('label.coupon.banner.aria')} className={`banner banner--${type}`}>
                <FadeTransition appear={isAnimated} in={isPullAnimationDone}>
                  <div className={contentClass}>
                    <button className="banner-mobile__close btn-reset" onMouseDown={onClose}>
                      <BcsCloseIcon />
                      <span className="visually-hidden">{translate('label.coupon.banner.close')}</span>
                    </button>
                    <a onMouseDown={() => setIsOpen(true)} className="subscription-modal__description-banner">
                      {title}
                    </a>
                  </div>
                </FadeTransition>
              </div>
            </PullUpTransition>
          )}
          {isShowingDetails &&
            <Modal
              id="BannerCouponContentModal"
              firstFocusElement="#coupon-banner-terms-close"
              onBackgroundClick={handleCloseDetails}
              onEscapeKey={handleCloseDetails}
              onExitFn={handleCloseDetails}
              modalTitle={translate('label.customer.discount')}
              modalContentClass={defaultStyles.modalContent}
              overlayClass={styles.overlay}
              showModal={isShowingDetails}
            >
              <CouponDetails
                onClose={handleCloseDetails}
                onStartChat={startChat}
                {...restrictions}
              />
            </Modal>
          }
          <Modal
            id="subscribeModal"
            modalTitle="Complete The Look"
            showModal={isOpen}
            firstFocusElement="span"
            onExitFn={onModalBackgroundClick}
            onBackgroundClick={onModalBackgroundClick}
            onEscapeKey={onModalBackgroundClick}
            modalContentClass="subscribe-modal__wrapper"
            overlayClass="subscribe__overlay"
          >
            <>
              <SubscribeBody
                {...props}
                title={title}
                closeModal={onModalBackgroundClick}
                handleOpenDetails={handleOpenDetails}
              />
            </>
          </Modal>
        </>
  );
};

SubscribeModal.propTypes = {
  isAnimated: PropTypes.bool,
  closeBanner: PropTypes.func,
  type: PropTypes.string.isRequired,
  handleCloseDetails: PropTypes.func.isRequired,
  handleOpenDetails: PropTypes.func.isRequired,
  isShowingDetails: PropTypes.bool.isRequired,
  startChat: PropTypes.func.isRequired,
  restrictions: PropTypes.object.isRequired,
  jsonDataTest: PropTypes.object,
};

export default SubscribeModal;
